/**
 * storageGateway模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios存储网关

const storageGateway = {
  //分页查看存储网关
  pageStorageGateway(params){
    return $http.post(`${global.API_URL}/sme/storageGateway/page`,params);
  },
  //存储网关删除
  deleteStorageGateway(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/storageGateway/delete`,param);
  },
  // 根据AccountId查询StorageGateway列表
  queryStorageGatewayByAccountId(params) {
    return $http.post(`${global.API_URL}/sme/storageGateway/queryStorageGatewayByAccountId`,params);
  },
  //查询存储网关
  queryStorageGateways(params){
    return $http.post(`${global.API_URL}/sme/storageGateway/queryStorageGateways`,params);
  },
  //查询当前组下所有存储网关
  selectQueryStorageGatewaysByGroupId(params) {
    return $http.post(`${global.API_URL}/sme/storageGateway/queryStorageGatewaysByGroupId`,params);
  },
  // 通过storageGatewayId查询存储网关
  getStorageGatewayDetailById(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/storageGateway/getStorageGatewayDetailById`,param);
  },
  // 通过storageGateway Name查询存储网关
  queryPatchStorageGatewayByStorageGatewayId(params) {
    return $http.post(`${global.API_URL}/sme/storageGateway/queryPatchStorageGatewayByStorageGatewayId`,params);
  }
}

export default storageGateway;



// WEBPACK FOOTER //
// ./src/api/storageGateway.js